module.exports = __webpack_public_path__ + "static/media/postcard.97aff1ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/postcard.svg
// module id = 1021
// module chunks = 43